var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconGingiva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-stroke",
    d: "m32.01,53.78c16.04,0,23.62-3.26,23.62-3.26l-2.52-12.41c-2.78,5.7-7.22,5.87-11.02,2.4h0c-2.63,3.75-7.33,3.87-10.08.02v-.02s0,0,0,.01c0,0,0,0,0-.01v.02c-2.75,3.85-7.46,3.73-10.08-.02h0c-3.8,3.47-8.24,3.3-11.02-2.4l-2.52,12.41s7.59,3.26,23.62,3.26h0s0,0,0,0,0,0,0,0h0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.16px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-stroke",
    d: "m31.99,9.46c-17.59,0-25.91,3.58-25.91,3.58l2.76,13.61c3.05-6.25,7.92-6.44,12.08-2.63h0c2.88-4.11,8.04-4.25,11.06-.02v.02s0,0,0-.01c0,0,0,0,0,.01v-.02c3.02-4.22,8.18-4.09,11.06.02h0c4.17-3.81,9.04-3.62,12.08,2.63l2.76-13.61s-8.32-3.58-25.91-3.58h0s0,0,0,0,0,0,0,0h0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.16px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconGingiva);
export default __webpack_public_path__ + "static/media/SDS_icon_Gingiva.628954b03af0de9d1f87d78bd2192c63.svg";
export { ForwardRef as ReactComponent };